import React from "react"
import { connect } from "react-redux"
import { keys, values, get } from "lodash"

import { push } from "connected-react-router"
import CoolPage from "../components/CoolPage"
import { texts, prices, prendasHombre, prendasMujer } from "./laundry.js"
import LaundryItem from "./Laundry.Item"
import { printMoney } from "../../../lib/Tools"

import "./Laundry.less"

// #TODO el botón de abajo en el diseño de paula tenía más cosas...

const lang = "ch"

const sum = (a, b) => (a + b)

function getText(k) {
  return get(texts, [k, lang], `[${k}][${lang}]`)
}

const kinds = { 1: "lavadoplan", 2: "planchar", 3: "lavadosec" }

function getItemPrice(key, number, kind) {
  return prices[key][kinds[kind]] * number
}

/* eslint-disable react/prefer-stateless-function */
class Laundry extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      tab: "m",
      selectionNumber: {},
      selectionKind: {},
      express: false
    }
  }
  
  getTotal() {
    return values(this.state.selectionNumber).reduce(((a, b) => a+b), 0)
  } 
  
  getTotalPrice() {
    const total = keys(this.state.selectionNumber)
      .map(key => {
        const kind = this.state.selectionKind[key] || 1
        const num = this.state.selectionNumber[key]
        console.log(`${num} x ${kind} = ${getItemPrice(key, num, kind)}`)
        return getItemPrice(key, num, kind)
      })
      .reduce(sum, 0)
    return this.state.express ? total * 2 : total
  }
  
  getCountPerGender(gender /* h|m */) {
    return keys(this.state.selectionNumber)
      .filter(k => k.startsWith(gender))
      .map(k => this.state.selectionNumber[k])
      .reduce(sum, 0)
  }
  
  render() {
    //console.log(this.state)
    return (
      <CoolPage
        containerProps={{ className: "tepa" }}
        title="洗衣服务"
        barColor={[255, 255, 255]}
        className="tepaPage tepaLaundry"
        fixedBar
        footerButton={true}
        footerLabel="送洗"
        onFooterClick={() => alert("DISABLED")}
      >
        <div className="serviceClassTabs">
          <div 
            className={!this.state.express ? "active" : ""}
            onClick={() => this.setState({ express: false })}
          >
            送回明天
          </div>
          <div 
            className={this.state.express ? "active" : ""}
            onClick={() => this.setState({ express: true })}
          >
            我需要送洗加急服务
          </div>
        </div>
      
        {/*<h1>请选择项目</h1>*/}
      
        <div className="stick">
          <div className="totals-wrapper">
            {/*<p>项目总数</p>*/}
            <h1>请选择项目</h1>
            <div className="totals">
              <img src="/static/icons/carrito.svg" />
              {this.getTotal()} 
              <img src="/static/icons/coin.svg" /> 
              {printMoney(this.getTotalPrice())}€
            </div>
          </div>
        
          <div className="tabs">
            <div 
              className={this.state.tab == "m" ? "active" : ""}
              onClick={() => this.setState({ tab: "m" })}
            >
              {
                this.state.tab == "m" 
                  ? <img src="/static/icons/woman_rouge.svg" /> 
                  : <img src="/static/icons/woman.svg" /> 
              } 
              <p>{getText("mujer")} ({this.getCountPerGender("m")})</p>
            </div>
            <div 
              className={this.state.tab == "h" ? "active" : ""}
              onClick={() => this.setState({ tab: "h" })}
            >
              {
                this.state.tab == "h" 
                  ? <img src="/static/icons/man_rouge.svg" /> 
                  : <img src="/static/icons/man.svg" /> 
              } 
              <p>{getText("hombre")} ({this.getCountPerGender("h")})</p>
            </div>
          </div>
        </div>
      
        <div className="list">
          {
            (this.state.tab == "m" ? prendasMujer : prendasHombre)
              .map(key => (
                <LaundryItem
                  key={key}
                  itemKey={key}
                  number={this.state.selectionNumber[key]}
                  kind={this.state.selectionKind[key] || 1}
                  text={texts[key]}
                  onSum={delta => {
                    const current = (this.state.selectionNumber[key] || 0) 
                    this.setState({
                      selectionNumber: {
                        ...this.state.selectionNumber,
                        [key]: Math.max(current + delta, 0)
                      }
                    })
                  }}
                  onKindChange={kind => {
                    this.setState({
                      selectionKind: {
                        ...this.state.selectionKind,
                        [key]: kind
                      }
                    })
                  }}
                />
              ))
          }
        </div>
      </CoolPage>
    )
  }
}

const mapStateToProps = (_state, _ownProps) => ({ })

const mapDispatchToProps = dispatch => {
  const goto = url => dispatch(push(url))
  return {
    goto,
    gotoSection: key => goto(`/catalogo/tepa/menu/${key}`)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Laundry)



// WEBPACK FOOTER //
// ./src/app/catalogo/hotels/Laundry.jsx